import { useEffect, useState, useCallback } from "react"
import { fetchS3Object } from 'utils/_function';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { refProjectIdState, currentLangState, latitudeCenterState, longitudeCenterState, datesState, myProjectIdState, qmaxValueState, pjNameState, zoomState } from 'atoms/projectData';

export const useHokudenMap = (accountGroupId, projectsTableData) => {

  // 北陸電力グループ専用機能(地図画像からMAP画面へ遷移)
  // Recoilから取得
  const qmaxDefaultValue = useRecoilValue(qmaxValueState);
  // Recoil更新関数を定義
  const setRefProjectId = useSetRecoilState(refProjectIdState);
  const setCurrentLang = useSetRecoilState(currentLangState);
  const setLatitudeCenter = useSetRecoilState(latitudeCenterState);
  const setLongitudeCenter = useSetRecoilState(longitudeCenterState);
  const setProjectDates = useSetRecoilState(datesState);
  const setMyProjectId = useSetRecoilState(myProjectIdState);
  const setQmaxValue = useSetRecoilState(qmaxValueState);
  const setPjName = useSetRecoilState(pjNameState);
  const setZoom = useSetRecoilState(zoomState);

  // Recoilに保存
  const handleChangeProjectId = (refProjectId, currentLang, latitudeCenter, longitudeCenter, date, projectId, qmaxValue, pjName) => {
    setRefProjectId(refProjectId);
    setCurrentLang(currentLang);
    setLatitudeCenter(latitudeCenter);
    setLongitudeCenter(longitudeCenter);
    setProjectDates(date);
    setMyProjectId(projectId);
    setQmaxValue(qmaxValue);
    setPjName(pjName);
    setZoom(12);
  }

  const [hokuden_map_url, setHokuden_map_url] = useState(null);
  const [hokudenMapHoverUrl1, setHokudenMapHoverUrl1] = useState(null);
  const [hokudenMapHoverUrl2, setHokudenMapHoverUrl2] = useState(null);
  const [hokudenMapHoverUrl3, setHokudenMapHoverUrl3] = useState(null);
  const [hokudenMapHoverUrl4, setHokudenMapHoverUrl4] = useState(null);
  const [hokudenMapHoverUrl5, setHokudenMapHoverUrl5] = useState(null);
  const [hokudenMapHoverUrl6, setHokudenMapHoverUrl6] = useState(null);
  const [hokudenMapOrig, setHokudenMapOrig] = useState(null);
  const [hokurikuMapProject, setHokurikuMapProject] = useState([]);

  useEffect(() => {
    if (accountGroupId !== "AG000013") return;
    if (projectsTableData.length === 0) return;

    // 特定のプロジェクトの情報だけ取得する
    const hokurikuProjectIds = [
      "-xPATkZRSVq5oxo1vG6r-A", // ①新_北側
      "rk0na6baRsOREcvH3Ugexw", // ②新＆常＆神_南側(新)_東側(常＆神)
      "bN33Q-ftS8CkCpapjDceHA", // ③常＆神＆手_西側(常＆神)_北東側(手)
      "-3M-t-R6S8S9YPyoAByyyw", // ④手&大_東側
      "PJ002443", // ⑤手_北西側
      "EM5L3GFMSNibxiFBBY-IKw", // ⑥手&大_西側
    ]

    // プロジェクト一覧から北陸電力のプロジェクトを抽出する
    const hokurikuIdSet = new Set(hokurikuProjectIds);
    const uniqueProjects = [];
    const seen = new Set(); // 重複チェック用
    projectsTableData.forEach((value) => {
      if (hokurikuProjectIds.includes(value.refProjectId)) {
        if (!hokurikuIdSet.has(value.refProjectId)) return;
        if (seen.has(value.refProjectId)) return;
        seen.add(value.refProjectId);
        uniqueProjects.push(value);
      };
    });
    setHokurikuMapProject(uniqueProjects);

    // 北陸電力用のマップ画像を用意
    (async () => {
      try {
        const map_img = await fetchS3Object('pub/img/hokuden-dashboard/hokuden_map.jpg');
        const map_img1 = await fetchS3Object('pub/img/hokuden-dashboard/hokuden_map1.jpg');
        const map_img2 = await fetchS3Object('pub/img/hokuden-dashboard/hokuden_map2.jpg');
        const map_img3 = await fetchS3Object('pub/img/hokuden-dashboard/hokuden_map3.jpg');
        const map_img4 = await fetchS3Object('pub/img/hokuden-dashboard/hokuden_map4.jpg');
        const map_img5 = await fetchS3Object('pub/img/hokuden-dashboard/hokuden_map5.jpg');
        const map_img6 = await fetchS3Object('pub/img/hokuden-dashboard/hokuden_map6.jpg');
        setHokuden_map_url(map_img);
        setHokudenMapOrig(map_img);
        setHokudenMapHoverUrl1(map_img1);
        setHokudenMapHoverUrl2(map_img2);
        setHokudenMapHoverUrl3(map_img3);
        setHokudenMapHoverUrl4(map_img4);
        setHokudenMapHoverUrl5(map_img5);
        setHokudenMapHoverUrl6(map_img6);
      } catch (err) {
        console.error('署名付きURL取得失敗', err);
      }
    })();
  }, [accountGroupId, projectsTableData]);


  const hokurikuMouseOver = (refProjectId) => {
    if (refProjectId === "-xPATkZRSVq5oxo1vG6r-A") setHokuden_map_url(hokudenMapHoverUrl1);
    if (refProjectId === "rk0na6baRsOREcvH3Ugexw") setHokuden_map_url(hokudenMapHoverUrl2);
    if (refProjectId === "bN33Q-ftS8CkCpapjDceHA") setHokuden_map_url(hokudenMapHoverUrl3);
    if (refProjectId === "-3M-t-R6S8S9YPyoAByyyw") setHokuden_map_url(hokudenMapHoverUrl4);
    if (refProjectId === "PJ002443") setHokuden_map_url(hokudenMapHoverUrl5);
    if (refProjectId === "EM5L3GFMSNibxiFBBY-IKw") setHokuden_map_url(hokudenMapHoverUrl6);
  }
  const hokurikuMouseRemove = useCallback(() => setHokuden_map_url(hokudenMapOrig), [hokudenMapOrig])

  return {
    hokuden_map_url,
    hokurikuMapProject,
    hokurikuMouseOver,
    hokurikuMouseRemove,
    handleChangeProjectId,
    qmaxDefaultValue,
  }
}